console.log('js');

// init language selector
var langSelect = document.querySelector('.header-lang-selector .disclosure');
var langList = document.querySelector('.header-lang-selector #lang-list');
var langListItem = document.querySelectorAll('.header-lang-selector .disclosure-list__option');

langSelect.addEventListener('click', function() {
	langList.classList.toggle('reveal')
})

langListItem.forEach(langItem => {
	langItem.addEventListener('click', function() {
		let langForm = document.querySelector('.header-lang-selector #localization_form');
		let langFormInput = document.querySelector('.header-lang-selector #LocaleSelector');

		langFormInput.value = this.dataset.value;
		langForm.submit();
	})
})


